// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__-dTEz","slowFade":"footer_slowFade__j+6X8"};